module.exports = __webpack_public_path__ + "static/img/coming-soon.b053164c.png";